import { OktaAuth } from '@okta/okta-auth-js';

const oktaIssuerURL = process.env.REACT_APP_ISSUER_URL as string;
const appClientID = process.env.REACT_APP_CLIENT_ID as string;

const oktaAuth = new OktaAuth({
    issuer: `${oktaIssuerURL}`,
    clientId: `${appClientID}`,
    redirectUri: window.location.origin + '/callback',
    scopes: ['openid', 'offline_access', 'profile', 'email'],
    // okta-auth-js 8.x no longer decodes access tokens by default.
    // Keep legacy behavior because the app reads authState.accessToken.claims in many places.
    decodeAccessTokens: true,
    pkce: true,
});

export default oktaAuth;
